import { IParameter } from "../parameter";
import { ICenter } from "../center";
import { ITraceable } from "../_traceable";
import IDeviceProperty from "./deviceProperty";

enum CommunicationMode {
  Push = 1,
  QuestionReponse,
  TempsImparti,
  None = 404,
}

/** Objet matériel */
interface IDevice extends ITraceable {

  /** Nom du matériel */
  name: string;

  // IDs for hydration
  typeId: number;
  centerId: number;

  /** Paramètre contenant le type du matériel */
  type: IParameter;

  /** Paramètre contenant le centre du device */
  center: ICenter;

  properties: IDeviceProperty[];
}

export { type IDevice, CommunicationMode };
